import {
    ADMINADDLANGUAGE_SUCCESS,
    ADMINADDLANGUAGE_FAILED,
    RESET_ADMINADDLANGUAGE,
    LOADING_ADMINADDLANGUAGE,
    NETWORK_ERROR_ADMINADDLANGUAGE
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMINADDLANGUAGE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMINADDLANGUAGE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMINADDLANGUAGE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMINADDLANGUAGE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMINADDLANGUAGE:
            return (state = initialState);
        default:
            return state;
    }
};